import styled from "styled-components";
import { FlexContainers, Paragraph2 } from "../../../../components";

export const DownloadingStepWrapper = styled(FlexContainers.FlexColumnStart)`
  max-width: 325px;
  gap: 16px;
  text-align: center;

  ${Paragraph2} {
    font-weight: 700;
  }
`;
